import { useMemo } from "react";
import ReactECharts from "echarts-for-react";

export const GIGA_PALETTE = ["#4285F4", "#DB4437", "#F4B400", "#0F9D58", "#AB47BC", "#00ACC1", "#FF7043", "#5C6BC0"];

const GigaVolumeChart = ({ labels = [], series = [], height = 320 }) => {
	const option = useMemo(
		() => ({
			color: GIGA_PALETTE,
			tooltip: { trigger: "axis" },
			legend: { type: "scroll", bottom: 0 },
			grid: { left: 48, right: 24, top: 24, bottom: 56 },
			xAxis: {
				type: "category",
				data: labels,
				axisLabel: { rotate: labels.length > 8 ? 30 : 0, fontSize: 11 },
			},
			yAxis: { type: "value", splitLine: { lineStyle: { color: "#eee" } } },
			series: (series || []).map((item) => ({
				name: item.name,
				type: "line",
				smooth: true,
				showSymbol: true,
				symbolSize: 6,
				data: item.data || [],
			})),
		}),
		[labels, series]
	);

	if (!labels.length || !series.length) return null;

	return <ReactECharts option={option} style={{ height, width: "100%" }} notMerge />;
};

export default GigaVolumeChart;
